import { render, staticRenderFns } from "./DashboardSearch.vue?vue&type=template&id=1cf168ea&"
import script from "./DashboardSearch.vue?vue&type=script&lang=js&"
export * from "./DashboardSearch.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports